<template>
  <div>
    <v-layout justify-space-between align-center mb-4>
      <v-btn
        v-if="common.hasPermissions('users', ['create'])"
        round
        color="primary"
        @click="addUser"
        >Add User</v-btn
      >

      <v-btn-toggle v-model="usersTabs" style="background: transparent">
        <v-btn flat @click="filterUsersByStatus('all')">All</v-btn>
        <v-btn flat @click="filterUsersByStatus('pending')">
          <span v-if="pendingUsersCount" class="badge">{{
            pendingUsersCount
          }}</span>
          Pending
        </v-btn>
      </v-btn-toggle>

      <v-btn-toggle v-model="view" style="background: transparent">
        <v-btn flat><v-icon>mdi-view-list</v-icon></v-btn>
        <v-btn flat><v-icon>mdi-view-grid</v-icon></v-btn>
      </v-btn-toggle>
    </v-layout>
    <v-dialog v-model="dialog" width="600">
      <users-edit-dialog
        :input-mode="inputMode"
        :user-data="userToEdit"
        :roles="roles"
        @closeDialog="dialog = false"
        @userAdded="pushUser"
        @userEdited="userEdited"
      ></users-edit-dialog>
    </v-dialog>
    <v-dialog v-model="deleteDialog" width="500">
      <delete-dialog
        :title="`${userToEdit.first_name}`"
        @onDelete="deleteUser(userToEdit.id)"
        @closeDialog="deleteDialog = false"
      ></delete-dialog>
    </v-dialog>

    <v-dialog v-model="updateStatusDialog" width="500">
      <updateUserStatus
        :user-data="userToEdit"
        :roles="roles"
        @closeDialog="updateStatusDialog = false"
      />
    </v-dialog>

    <v-dialog v-model="commentDialog" width="600">
      <v-card>
        <v-card-title class="">
          <h3>
            ({{ userToEdit.first_name }} {{ userToEdit.last_name }}) Review
            Comment
          </h3>
        </v-card-title>

        <v-card-text>
          {{ userToEdit.comment }}
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card v-if="view === 0" class="rounded-box" flat>
      <v-card-title class="pt-0 px-0">
        <v-text-field
          v-model="search"
          append-icon="search"
          class="ma-0 pa-0"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-layout justify-space-between align-center>
          <div class="px-3">Filter by Status</div>
          <v-select
            v-model="filter.status"
            :items="['all', 'pending', 'approved', 'rejected', 'blocked']"
            label="Status"
            class="ma-0 pa-0"
            single-line
            hide-details
            @change="getUsers"
          ></v-select>
        </v-layout>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="users"
        :search="search"
        :rows-per-page-items="[
          10,
          25,
          { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
        ]"
      >
        <template v-slot:items="{ item }">
          <td>{{ item.first_name }} {{ item.last_name }}</td>
          <td>{{ item.email }}</td>
          <td>
            <v-chip
              small
              :color="statusColors[item.status]"
              text-color="white"
              >{{ item.status }}</v-chip
            >
          </td>
          <td>{{ item.role }}</td>
          <td>{{ item.reviewed_by }}</td>
          <td>
            <v-btn
              class="px-2 py-0"
              flat
              small
              v-if="item.comment"
              @click="showComment(item)"
              >view comment</v-btn
            >
          </td>

          <td v-if="common.hasPermissions('users', ['updateStatus'])">
            <v-btn
              flat
              small
              @click="openUpdateStatusDialog(item)"
              class="ma-0 px-0"
              ><v-icon small left>mdi-eye</v-icon> Review</v-btn
            >
          </td>
          <td
            v-if="
              common.hasPermissions('users', ['update']) ||
              common.hasPermissions('users', ['delete'])
            "
          >
            <v-layout row wrap justify-center>
              <v-icon
                v-if="common.hasPermissions('users', ['update'])"
                small
                class="mr-2"
                @click="editUser(item)"
                >mdi-pencil</v-icon
              >
              <v-icon
                v-if="common.hasPermissions('users', ['delete'])"
                small
                @click="openDeleteDialog(item)"
                >mdi-delete</v-icon
              >
            </v-layout>
          </td>
        </template>
      </v-data-table>
    </v-card>

    <v-layout v-else wrap>
      <v-flex md3 v-for="user in users" :key="user.id">
        <div class="card-curvey text-xs-center mt-0" primary-title>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn dark icon v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-tile-title
                v-if="common.hasPermissions('users', ['updateStatus'])"
                class="pointer mb-3"
                @click="openUpdateStatusDialog(user)"
              >
                <v-icon>mdi-eye</v-icon> <span class="mr-2 ml-2">Review</span>
              </v-list-tile-title>
              <v-list-tile-title
                v-if="common.hasPermissions('users', ['update'])"
                class="pointer mb-3"
                @click="editUser(user)"
              >
                <v-icon>edit</v-icon> <span class="mr-2 ml-2">Edit</span>
              </v-list-tile-title>
              <v-list-tile-title
                v-if="common.hasPermissions('users', ['delete'])"
                class="pointer"
                @click="openDeleteDialog(user)"
              >
                <v-icon>delete</v-icon><span class="mr-2 ml-2">Delete</span>
              </v-list-tile-title>
            </v-list>
          </v-menu>
          <div class="bot-info">
            <span class="icon-wrapper">
              <v-icon>mdi-account-outline</v-icon>
            </span>
            <div class="px-3">
              <h3 class="mb-0">{{ user.first_name }} {{ user.last_name }}</h3>
              <v-chip small>{{ user.role }}</v-chip>
              <p class="text-truncate mt-1">{{ user.email }}</p>
              <v-chip
                class=""
                :color="statusColors[user.status]"
                text-color="white"
              >
                {{ user.status }}
              </v-chip>
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import _ from "lodash";
import common from "../../utils/common";
import deleteDialog from "../common/deleteDialog";
import updateUserStatus from "./updateUserStatus.vue";
import usersEditDialog from "./usersAddOrEdit";
export default {
  name: "users",
  components: {
    deleteDialog,
    usersEditDialog,
    updateUserStatus,
  },
  data() {
    return {
      common,
      view: 0,
      inputMode: "",
      userToEdit: {},
      dialog: false,
      deleteDialog: false,
      updateStatusDialog: false,
      commentDialog: false,
      users: [],
      search: "",
      filter: {
        status: "all",
      },
      usersTabs: 0,
      statusColors: {
        pending: "warning",
        approved: "success",
        rejected: "error",
        blocked: "error",
        locked: "error",
      },
    };
  },
  async mounted() {
    await this.getUsers();
    await this.$store.dispatch("fetchRoles");
  },
  computed: {
    headers() {
      return [
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Status", value: "status" },
        { text: "Role", value: "role" },
        { text: "Reviewed By", value: "reviewed_by" },
        { text: "Review Comment", value: "comment", sortable: false },
        { text: "Review", value: "review", sortable: false },
        { text: "Actions", value: "action", align: "center" },
      ].filter((header) => {
        if (header.value === "review") {
          return this.common.hasPermissions("users", ["updateStatus"]);
        } else if (header.value === "action") {
          return (
            this.common.hasPermissions("users", ["update"]) ||
            this.common.hasPermissions("users", ["delete"])
          );
        }

        return true;
      });
    },
    roles() {
      return this.$store.state.user.roles;
    },
    pendingUsersCount() {
      return this.users.filter((user) => user.status === "pending").length;
    },
  },
  methods: {
    async filterUsersByStatus(status) {
      this.filter.status = status;
      await this.getUsers();
    },
    async getUsers() {
      const query =
        this.filter.status === "all" ? "" : `status=${this.filter.status}`;
      const response = await this.$http.get(`/users/?${query}`);

      this.users = response.data;
      // console.log(this.users, ' users')
    },
    getRoleName(id) {
      const role = this.roles.find((role) => {
        return role.value == id;
      });
      return (role && role.name) || "";
    },
    editUser(user) {
      this.userToEdit = user;
      this.inputMode = "edit";
      this.dialog = true;
    },
    openDeleteDialog(user) {
      this.userToEdit = user;
      this.deleteDialog = true;
    },
    openUpdateStatusDialog(user) {
      this.userToEdit = JSON.parse(JSON.stringify(user));
      this.updateStatusDialog = true;
    },
    async deleteUser(userid) {
      let index = -1;
      let that = this;
      this.deleteDialog = false;
      await this.$http.delete(`/users/${userid}`);

      // debugger
      index = _.findIndex(that.users, (o) => {
        return o.id === userid;
      });
      if (index !== -1) {
        that.users.splice(index, 1);
        // console.log(that.users)
      }
    },
    addUser() {
      this.userToEdit = {
        corporate_id: this.$store.state.user.userData.corporate_id,
      };
      this.inputMode = "add";
      this.dialog = true;
    },
    pushUser(user) {
      const userToPush = _.cloneDeep(user);
      this.users.push(userToPush);
    },
    userEdited(user) {
      let index = _.findIndex(this.users, (o) => {
        return o.id === this.user.id;
      });
      if (index !== -1) {
        this.users[index] = _.cloneDeep(user);
      }
    },
    showComment(user) {
      this.userToEdit = user;
      this.commentDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-menu__content {
  padding: 1rem;
  background: #ffffff;
}

table.v-table tbody td {
  padding: 10px 20px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}

.card-curvey {
  // height: 190px;
  width: 100%;
  position: relative;
  border-radius: 10px;
  padding: 16px 0px;

  .v-btn.v-btn--icon {
    color: #bcbcbc;
    position: absolute;
    top: 5px;
    right: 5px;
    padding: 0;
  }

  .bot-info {
    span.icon-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background-color: #0d1633;
      margin: 0 auto 0.5rem;

      i {
        color: #ffffff;
        font-size: 30px;
      }
    }

    h3 {
      color: #0d1633;
    }

    p {
      margin-bottom: 0.5rem;
    }

    .v-chip {
      background-color: rgba(0, 0, 0, 0.15);
      color: #000000;
      padding: 0 1rem;
    }
  }
}
.pointer {
  cursor: pointer;
}
.badge {
  background: #f44336;
  color: #ffffff;
  padding: 1px 5px;
  border-radius: 100px;
  margin: 0 5px;
}
</style>
